import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { Modal } from '@calendly/ui/components/modal';
import { Sheet } from '@calendly/ui/components/sheet';
import { HeadingText, BodyText } from '@calendly/ui/components/typography';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useRemoveContactMutation } from 'features/contacts/api';
import { StickyFooter } from 'features/layout';
import { FullStoryMask } from '../../../shared/fullstory_privacy';
const modalContainerCss = "m1i964st";
const ModalContainer = forwardRef((props, ref) => <Sheet ref={ref} {...props} className={classNames(modalContainerCss, props.className)} />);
const contentCss = "c1ealo58";
const Content = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(contentCss, props.className)} />;
});
const headerCss = "h1guzq8s";
const Header = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(headerCss, props.className)} />;
});
const footerCss = "f1kbzpv9";
const Footer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(footerCss, props.className)} />;
});
const buttonStylingCss = "b1u5odyu";
const ButtonStyling = forwardRef((props, ref) => <Button ref={ref} {...props} className={classNames(buttonStylingCss, props.className)} />);
const containerCss = "c1mw22ne";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const ModalContent = ({
  name,
  onClose,
  handleRemoveButton,
  textSize
}) => <Content>
    <Header>
      <HeadingText level={textSize}>
        <FullStoryMask>
          {I18n.t('publisher.contacts.remove_contact_modal.header', {
          name
        })}
        </FullStoryMask>
      </HeadingText>
    </Header>
    <BodyText>
      {I18n.t('publisher.contacts.remove_contact_modal.message')}
    </BodyText>
    <Footer>
      <ButtonStyling decoration="secondary-outline" onClick={onClose}>
        {I18n.t('publisher.contacts.remove_contact_modal.cancel')}
      </ButtonStyling>
      <ButtonStyling onClick={handleRemoveButton}>
        {' '}
        {I18n.t('publisher.contacts.remove_contact_modal.remove')}
        {' '}
      </ButtonStyling>
    </Footer>
  </Content>;
export const RemoveContactModal = ({
  isModalOpen,
  onClose,
  uuid,
  name
}) => {
  const [removeContact] = useRemoveContactMutation();
  const isMobile = useDeviceType('isPhone');
  const handleRemoveButton = () => {
    const updateParams = {
      contact: {
        uuid,
        visible: false
      }
    };
    removeContact(updateParams);
    onClose();
  };
  return <Container>
      {!isMobile && <Modal isOpen={isModalOpen} onClose={onClose}>
            <ModalContainer>
              <ModalContent name={name} onClose={onClose} handleRemoveButton={handleRemoveButton} textSize={2} />
            </ModalContainer>
          </Modal>}
      {isMobile && isModalOpen && <StickyFooter>
            <ModalContent name={name} onClose={onClose} handleRemoveButton={handleRemoveButton} textSize={3} />
          </StickyFooter>}
    </Container>;
};

require("./remove_contact_modal.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./remove_contact_modal.js");